import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FlexModule} from '@angular/flex-layout';
import {UserPhotoComponent} from './user-photo.component';
import {MatTooltipModule} from '@angular/material/tooltip';

@NgModule({
    declarations: [
        UserPhotoComponent
    ],
    exports: [
        UserPhotoComponent
    ],
    imports: [
        CommonModule,
        FlexModule,
        MatTooltipModule,
    ]
})
export class UserPhotoModule {
}
